export enum EUserType {
    ROOT = 'ROOT',
    ADMIN = 'ADMIN',
    BILLER = 'BILLER',
    CLIENT = 'CLIENT',
}
